module.exports = __webpack_public_path__ + "img/icon-partner-usa.c9092bf4.svg";